'use strict';
/**
 * @author Maxim Seredkin
 */


export default ['$scope', 'StaffService',
    function ($scope, StaffService) {

        $scope.curators = [];

        StaffService.api.get({
            filters: ["'org.mizip' EQ 'true'"],
            sorts: ['surname:ASC', 'firstName:ASC', 'middleName:ASC']
        }, function (data) {
            $scope.curators = data._embedded;
        });
    }];
